<template>
  <avtalat-select
    id="kanal"
    v-model:value="kanal"
    label="Kanal"
    :required="required"
    :disabled="disabled"
  >
    <option value="" disabled>Välj ett alternativ</option>
    <option v-for="(item, index) in options" :key="index" :value="item.id">
      {{ item.label }}
    </option>
  </avtalat-select>
</template>

<script setup lang="ts">
import type { KanalType } from "@/composables/KundserviceAppApiClient";
import type { Option } from "@/types/form";

const kanal = defineModel<KanalType>();

defineProps<{
  required: boolean;
  disabled?: boolean | null | undefined;
  options: Option[];
}>();
</script>
